import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/App";
import { AppErrorBoundary, initSentry } from "@/shared/sentry";
import "@/styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary
      fallback={
        <main style={{ padding: 32 }}>
          <h1>Something went wrong.</h1>
          <p>We've been notified. Refresh to try again.</p>
        </main>
      }
    >
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);

// Defer Sentry init off the first-paint critical path. The SDK chunk is
// dynamically imported inside initSentry, so this also keeps ~30 KB gz of
// Sentry out of the main bundle. requestIdleCallback isn't in every browser
// (Safari) - fall back to a 1s setTimeout. Errors before init are caught by
// AppErrorBoundary and logged to console; they just don't ship to Sentry.
const scheduleSentry = (cb: () => void) => {
  if (typeof window === "undefined") return;
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(cb, { timeout: 3000 });
  } else {
    setTimeout(cb, 1000);
  }
};
scheduleSentry(() => {
  void initSentry();
});
